import { CreateRequest, DebounceUseCase, GetLink, Http, Resource } from '@mdd/api';
import { ReplaceParams } from './ReplaceParams';

export namespace GetResourceWithParams {
    export interface Params<L extends string> {
        parent: Resource<L>;
        rel: L;
        queryParams?: object;
    }
}

export class GetResourceWithParams<L extends string, T> extends DebounceUseCase<
    GetResourceWithParams.Params<L>,
    T
> {
    private getLink = new GetLink<L>();
    private createRequest = new CreateRequest();
    private replaceParams = new ReplaceParams<string>();

    constructor(private http: Http) {
        super();
    }

    protected debounceExecute({
        parent,
        rel,
        queryParams
    }: GetResourceWithParams.Params<L>): Promise<T> {
        let link = this.getLink.execute({ parent, rel })!.href;
        if (link) {
            if (queryParams) {
                link = this.replaceParams.execute({ link, queryParams });
            }

            return this.http
                .request<void, T>(
                    this.createRequest.execute({
                        method: 'GET',
                        url: link
                    })
                )
                .then((response) => response.body!);
        } else {
            return Promise.reject(new Error(`${rel} link does not exist`));
        }
    }
}
